import { render, staticRenderFns } from "./AddPrintShop.vue?vue&type=template&id=6f7ae15a&"
import script from "./AddPrintShop.vue?vue&type=script&lang=js&"
export * from "./AddPrintShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/AddPrintShop.vue
// module id = null
// module chunks = 